<template>
  <v-dialog v-model="show" persistent max-width="650px">
    <v-card>
      <v-toolbar color="pageHeader" dark height="40px">
        <v-btn icon>
          <v-icon>mdi-lock</v-icon>
        </v-btn>
        <span>{{ $t("changePassword") }}</span>
      </v-toolbar>

      <v-card-text>
        <v-form ref="refPasswordForm" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.trim="currentPassword"
                  :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="currentPasswordRules"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  required
                  name="input-current-password"
                  :label="`${$t('lblCurrentPassword')} *`"
                  @click:append="showCurrentPassword = !showCurrentPassword"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.trim="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules.concat(passwordValidation)"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  name="input-password"
                  :label="`${$t('lblPassword')} *`"
                  @click:append="showPassword = !showPassword"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.trim="confirmPassword"
                  :append-icon="showCnfPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="reqCnfRules.concat(passwordConfirmationRule)"
                  :type="showCnfPassword ? 'text' : 'password'"
                  required
                  name="input-cnf-password"
                  :label="`${$t('lblConfirmPassword')} *`"
                  @click:append="showCnfPassword = !showCnfPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
          <span style="font-size: 14px">{{ $t("lblLogOff") }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="pageHeader" text @click="onSubmit()">{{
          $t("btnSubmit")
        }}</v-btn>
        <v-btn color="pageHeader" text @click="close()">{{
          $t("btnClose")
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import MessageSheet from "./MessageSheet.vue";
export default {
  name: "ChangePassword",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCnfPassword: false,
      confirmPassword: "",
      showPassword: false,
      showCurrentPassword: false,
      currentPassword: "",
      password: "",
      valid: false,
      passwordRules: [(v) => !!v.trim() || this.$t("rulePasswordReq")],
      currentPasswordRules: [
        (v) => !!v.trim() || this.$t("ruleCurrentPasswordReq"),
      ],
      reqCnfRules: [(v) => !!v.trim() || this.$t("ruleConfirmPasswordReq")],
      displayMessage: false,
      message: "",
      messageType: "",
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || this.$t("rulePasswordMatch");
    },
    rules() {
      return [
        { message: this.$t("lowerCaseRule"), regex: /[a-z]+/ },
        { message: this.$t("upperCaseRule"), regex: /[A-Z]+/ },
        { message: this.$t("lengthRule"), regex: /.{8,}/ },
        { message: this.$t("numberRule"), regex: /[0-9]+/ },
        { message: this.$t("specialCharactorRule"), regex: /[!@#$%^&*]+/ },
      ];
    },
    passwordValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return true;
      } else {
        return errors;
      }
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
  },
  methods: {
    ...mapActions({
      changeUserPassword: "admin/changeUserPassword",
    }),
    close,
    onSubmit,
    showMessageSheet,
  },
  components: { MessageSheet },
};

function showMessageSheet(message, messageType) {
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

async function onSubmit() {
  try {
    if (this.$refs.refPasswordForm.validate()) {
      const data = {
        current_password: this.currentPassword,
        password: this.password,
        user_id: this.$auth.user.sub,
        tenantid: sessionStorage.getItem("tenantId"),
      };
      const result = await this.changeUserPassword(data);
      if (result.statusCode === 400) {
        this.showMessageSheet(result.message, "error");
      } else {
        this.$store.commit("setAlert", {
          variant: "success",
          message: this.$t("msgPasswordChanged"),
        });
        this.close();
        this.$auth.logout();
        this.$router.push({ path: "/" });
      }
    }
  } catch (error) {
    console.log(error);
  }
}

function close() {
  this.$refs.refPasswordForm.resetValidation();
  this.$refs.refPasswordForm.reset();
  this.$emit("input", false);
}
</script>

<style>
</style>